module.exports = "/_next/static/images/front_0-71a9e1765b74feb2613b97e571f60548.jpg";